import "../styles/Footer.scss";
import title from "../assets/keepInTouch.png";
import AnchorLink from "react-anchor-link-smooth-scroll-ts";
import goTop from "../assets/top.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="titleFooter">
        <img src={title} className="keepInTouch" alt="keep in touch" />
      </div>
      <div className="icons">
        <a href="mailto:bazire.fabien@gmail.com" className="iconMail" aria-label="Envoyer un mail">
          <span className="icon-tooltip">bazire.fabien@gmail.com</span>
        </a>
        <a href="tel:0650393728" className="iconPhone" aria-label="Appeler">
          <span className="icon-tooltip">06 50 39 37 28</span>
        </a>
        {/* <div className="iconLinkedin"></div> */}
        <a href="/curriculum.jpg" download="curriculum.jpg" className="iconCV" aria-label="Télécharger le CV">
          <span className="icon-tooltip">Curriculum Vitae</span>
        </a>
      </div>
      <section id="sectionContact"></section>

      <AnchorLink href="#sectionHeader">
        <img src={goTop} className="top" alt="top"></img>
      </AnchorLink>
    </div>
  );
};

export default Footer;
